import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import { getLocale } from '../locale'; // import icons from '../icons'

import { getKey } from '../utils/uid';
import List from '../AnimationList';
import Spin from '../Spin'; // import Input from '../Input'

import Checkbox from '../Checkbox/Checkbox';
import { selectClass } from './styles';
import BoxOption from './BoxOption';
import LazyList from '../AnimationList/LazyList';
import { getCustomList } from './utils';
var ScaleList = List(['fade', 'scale-y'], 'fast', 'flex');

var emptyFunc = function emptyFunc() {};

var DefaultValue = {
  columnWidth: 160
};

var BoxList =
/*#__PURE__*/
function (_Component) {
  _inherits(BoxList, _Component);

  var _super = _createSuper2(BoxList);

  function BoxList(props) {
    var _this;

    _classCallCheck(this, BoxList);

    _this = _super.call(this, props); // fake events

    _this.handleMouseMove = void 0;
    props.bindOptionFunc('handleHover', emptyFunc);
    props.bindOptionFunc('hoverMove', emptyFunc);
    props.bindOptionFunc('getIndex', emptyFunc);
    _this.handleSelectAll = _this.handleSelectAll.bind(_assertThisInitialized(_this));
    _this.handleRenderItem = _this.handleRenderItem.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(BoxList, [{
    key: "getText",
    value: function getText(key) {
      return this.props.text[key] || getLocale(key);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      var _this$props = this.props,
          _this$props$columnWid = _this$props.columnWidth,
          columnWidth = _this$props$columnWid === void 0 ? DefaultValue.columnWidth : _this$props$columnWid,
          columns = _this$props.columns;
      if (columns === -1) return columnWidth;
      return columnWidth * columns;
    }
  }, {
    key: "handleSelectAll",
    value: function handleSelectAll(_, checked) {
      var _this$props2 = this.props,
          datum = _this$props2.datum,
          data = _this$props2.data;
      if (checked) datum.add(data);else datum.remove(data);
    }
  }, {
    key: "handleRenderItem",
    value: function handleRenderItem(data, groupIndex) {
      var _this$props3 = this.props,
          datum = _this$props3.datum,
          keygen = _this$props3.keygen,
          columns = _this$props3.columns,
          multiple = _this$props3.multiple,
          onChange = _this$props3.onChange,
          renderItem = _this$props3.renderItem,
          lineHeight = _this$props3.lineHeight;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            height: lineHeight
          }
        }, data.map(function (d, i) {
          var isActive = datum.check(d);
          return (
            /*#__PURE__*/
            React.createElement(BoxOption, {
              key: getKey(d, keygen, groupIndex + i),
              isActive: isActive,
              disabled: datum.disabled(d),
              data: d,
              columns: columns,
              multiple: multiple,
              onClick: onChange,
              renderItem: renderItem
            })
          );
        }))
      );
    }
  }, {
    key: "renderHeader",
    value: function renderHeader(count) {
      var _this$props4 = this.props,
          data = _this$props4.data,
          loading = _this$props4.loading,
          multiple = _this$props4.multiple,
          columnsTitle = _this$props4.columnsTitle;
      if (loading || !multiple) return null;
      var checked = 'indeterminate';
      if (count === 0) checked = false;else if (count === data.length) checked = true;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: selectClass('header')
        }, multiple &&
        /*#__PURE__*/
        React.createElement(Checkbox, {
          onChange: this.handleSelectAll,
          checked: checked
        }, this.getText('selectAll')), columnsTitle &&
        /*#__PURE__*/
        React.createElement("span", {
          className: selectClass('header-title')
        }, columnsTitle))
      );
    }
  }, {
    key: "renderLazyList",
    value: function renderLazyList() {
      var _this$props5 = this.props,
          columns = _this$props5.columns,
          height = _this$props5.height,
          lineHeight = _this$props5.lineHeight,
          data = _this$props5.data,
          itemsInView = _this$props5.itemsInView;
      var sliceData = data.reduce(function (red, item) {
        var lastItem = red[red.length - 1];

        if (!lastItem) {
          lastItem = [];
          red.push(lastItem);
        }

        if (lastItem.length >= columns) red.push([item]);else lastItem.push(item);
        return red;
      }, []);
      return (
        /*#__PURE__*/
        React.createElement(LazyList, {
          lineHeight: lineHeight,
          data: sliceData,
          itemsInView: itemsInView,
          height: height,
          renderItem: this.handleRenderItem
        })
      );
    }
  }, {
    key: "renderStack",
    value: function renderStack() {
      var _this$props6 = this.props,
          columns = _this$props6.columns,
          datum = _this$props6.datum,
          multiple = _this$props6.multiple,
          onChange = _this$props6.onChange,
          renderItem = _this$props6.renderItem,
          data = _this$props6.data,
          keygen = _this$props6.keygen;
      return data.map(function (d, i) {
        var isActive = datum.check(d);
        return (
          /*#__PURE__*/
          React.createElement(BoxOption, {
            key: getKey(d, keygen, i),
            isActive: isActive,
            disabled: datum.disabled(d),
            data: d,
            columns: columns,
            multiple: multiple,
            onClick: onChange,
            renderItem: renderItem
          })
        );
      });
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this$props7 = this.props,
          loading = _this$props7.loading,
          columns = _this$props7.columns,
          data = _this$props7.data,
          renderPending = _this$props7.renderPending,
          emptyText = _this$props7.emptyText;
      if (loading) return null;
      var stack = columns === -1;
      var empty = renderPending || data.length === 0;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: selectClass('box-options', stack && 'scrollable')
        }, empty ?
        /*#__PURE__*/
        React.createElement("div", {
          key: "empty",
          className: selectClass('no-data')
        }, emptyText || this.getText('noData')) :
        /*#__PURE__*/
        React.createElement(React.Fragment, null, stack ? this.renderStack() : this.renderLazyList()))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          data = _this$props8.data,
          datum = _this$props8.datum,
          style = _this$props8.style,
          loading = _this$props8.loading,
          focus = _this$props8.focus,
          selectId = _this$props8.selectId,
          getRef = _this$props8.getRef,
          customHeader = _this$props8.customHeader,
          renderOptionList = _this$props8.renderOptionList;
      var checkedCount = data.filter(function (d) {
        return datum.check(d);
      }).length;
      var newStyle = Object.assign({}, style, {
        width: this.getWidth()
      });
      var results =
      /*#__PURE__*/
      React.createElement(React.Fragment, null, customHeader, loading && typeof loading === 'boolean' ?
      /*#__PURE__*/
      React.createElement(Spin, {
        size: 30
      }) : loading, this.renderHeader(checkedCount), this.renderOptions());
      return (
        /*#__PURE__*/
        React.createElement(ScaleList, {
          show: focus,
          onMouseMove: this.handleMouseMove,
          "data-id": selectId,
          style: newStyle,
          className: selectClass('box-list'),
          getRef: getRef
        }, getCustomList(results, renderOptionList, loading))
      );
    }
  }]);

  return BoxList;
}(Component);

BoxList.defaultProps = DefaultValue;
export default BoxList;